module.exports = "<div class=round-button> <button class=\"no-pointers button\" ng-disabled=$ctrl.isDisabled ng-class=\"{ 'glass': $ctrl.glass, 'glow': $ctrl.glow, 'disabled-left': $ctrl.disabledDirection == 'left', 'disabled-right': $ctrl.disabledDirection == 'right' }\"> <div class=\"round-button-icon {{$ctrl.icon}}\" ng-class=\"{ 'inverted': $ctrl.inverted} \"></div> </button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/round-button/round-button.html
 ** module id = 62
 ** module chunks = 0
 **/